import { Offer } from '@App/interfaces/offer';
import { toPercentage } from '@Shared/helpers/numbers';

import { FeatureOption, IconType } from '../types';

export type RateFeatureType = 'interestRate' | 'aprc';

export const getProductCardFeatureOptions = (
    offer: Offer,
    rateFeatureType: RateFeatureType = 'interestRate',
): FeatureOption[] => {
    const isHomeownerLoan =
        offer.family === 'Homeowner Loan' && !offer.isVariable;

    const useFundsAllAtOnceLabel = 'Use your funds all at once';
    const noEarlyRepaymentFeesLabel = 'No early repayment fees';
    const prominentRateLabel =
        rateFeatureType === 'aprc'
            ? `${toPercentage(offer.aprc)} APRC`
            : `${offer.initialRate}% Interest rate`;

    if (offer.isVariable) {
        const featureOptions = [
            {
                label: prominentRateLabel,
                icon: IconType.TICK,
            },
            {
                label:
                    offer.family === 'HELOC'
                        ? 'Use your funds as needed'
                        : useFundsAllAtOnceLabel,
                icon: IconType.TICK,
            },
            { label: noEarlyRepaymentFeesLabel, icon: IconType.TICK },
        ];

        if (offer.family === 'HELOC' && offer.drawdownTerm) {
            featureOptions.push({
                label: `${offer.drawdownTerm} year flexible drawdown period`,
                icon: IconType.TICK,
            });
        }

        return featureOptions;
    }

    if (isHomeownerLoan) {
        const baseHomeownerOptions = [
            {
                label: prominentRateLabel,
                icon: IconType.TICK,
            },
            { label: useFundsAllAtOnceLabel, icon: IconType.TICK },
        ];

        if (offer.ercData.length === 0) {
            return [
                ...baseHomeownerOptions,
                {
                    label: `Fixed payments for ${offer.initialTerm} years`,
                    icon: IconType.TICK,
                },
                { label: noEarlyRepaymentFeesLabel, icon: IconType.TICK },
            ];
        }

        if (offer.ercData.length > 0) {
            return [
                ...baseHomeownerOptions,
                {
                    label: `Fixed payments for ${offer.initialTerm} years`,
                    icon: IconType.TICK,
                },
                {
                    label: 'Early repayment fees apply in fixed period',
                    icon: IconType.CROSS,
                },
            ];
        }
    }

    return [];
};
